import { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

import { useAppSelector } from 'redux/use-hooks';
import { RegisterContracts } from 'types';
import {
  selectAccountId,
  selectAccountLoadingContracts,
  selectAuthReady,
  selectRegisterContracts
} from 'redux/slices/account';

import { SIGNIN_PAGE } from 'site-settings/site-navigation';
import config from '../../../config';
const { PLANT_LIST } = config;

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();
  const accountId = useAppSelector(selectAccountId);
  const authReady = useAppSelector(selectAuthReady);
  const location = useLocation();
  const registerContracts = useAppSelector(
    selectRegisterContracts
  ) as RegisterContracts;
  const loadingContracts = useAppSelector(selectAccountLoadingContracts);

  useEffect(() => {
    if (!authReady || loadingContracts || !accountId) {
      return;
    }

    const isInContracts = Object.entries(registerContracts).every(
      (contract) => contract[1].value
    );
    if (!isInContracts) {
      navigate(`${SIGNIN_PAGE}?register_view=true`);
    }

    if (location.pathname === '/plant') {
      const inList = PLANT_LIST.includes(accountId);
      if (!inList) {
        navigate('/404');
      }
    }
  }, [
    authReady,
    accountId,
    loadingContracts,
    registerContracts,
    location.pathname,
    navigate
  ]);

  // Wait for Meteor/wallet-selector session restore before redirecting.
  if (!authReady) {
    return null;
  }

  if (!accountId) {
    return <Navigate to={SIGNIN_PAGE} replace />;
  }

  return accountId && <>{children}</>;
};

export default PrivateRoute;
